import { useState } from 'react';
import Layout from '../../components/feature/Layout';
import { utmRows } from '../../mocks/traffic';

export default function UtmAnalysis() {
  const [searchVal, setSearchVal] = useState('');
  const [filterSource, setFilterSource] = useState('all');
  const [filterMedium, setFilterMedium] = useState('all');
  const [expandedRow, setExpandedRow] = useState<number | null>(null);

  const filtered = utmRows.filter(r => {
    if (filterSource !== 'all' && r.utmSource !== filterSource) return false;
    if (filterMedium !== 'all' && r.utmMedium !== filterMedium) return false;
    if (searchVal && !r.utmCampaign.toLowerCase().includes(searchVal.toLowerCase()) && !r.utmSource.toLowerCase().includes(searchVal.toLowerCase())) return false;
    return true;
  });

  const kpiCards = [
    { label: 'Takip Edilen UTM', value: '47', icon: 'ri-link-m', color: '#D4AF37' },
    { label: 'Toplam Oturum', value: '9.760', icon: 'ri-global-line', color: '#64B5F6' },
    { label: 'Toplam Dönüşüm', value: '425', icon: 'ri-target-line', color: '#7CB342' },
    { label: 'Ort. Dönüşüm Oranı', value: '6.8%', icon: 'ri-percent-line', color: '#E8C87C' },
  ];

  return (
    <Layout>
      <div className="space-y-5">
        {/* KPI Row */}
        <div className="grid grid-cols-4 gap-4">
          {kpiCards.map(kpi => (
            <div key={kpi.label} className="bg-white rounded-2xl shadow-card p-5 flex items-center gap-4">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: `${kpi.color}15` }}>
                <i className={`${kpi.icon} text-[20px]`} style={{ color: kpi.color }} />
              </div>
              <div className="min-w-0">
                <p className="text-[11px] text-charcoal-300 truncate">{kpi.label}</p>
                <p className="text-[22px] font-bold text-charcoal-600 leading-tight">{kpi.value}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Filters */}
        <div className="bg-white rounded-2xl shadow-card p-5">
          <div className="flex flex-wrap gap-3 items-center">
            <div className="relative flex-1 min-w-[200px]">
              <div className="w-4 h-4 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2">
                <i className="ri-search-line text-charcoal-300 text-[14px]" />
              </div>
              <input value={searchVal} onChange={e => setSearchVal(e.target.value)} placeholder="UTM kampanya ara..." className="w-full h-[38px] pl-9 pr-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] placeholder-charcoal-300 focus:outline-none focus:border-champagne-400" />
            </div>
            <select value={filterSource} onChange={e => setFilterSource(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
              <option value="all">Tüm Kaynaklar</option>
              <option value="google">Google</option>
              <option value="instagram">Instagram</option>
              <option value="facebook">Facebook</option>
              <option value="tiktok">TikTok</option>
              <option value="youtube">YouTube</option>
              <option value="email">E-Posta</option>
            </select>
            <select value={filterMedium} onChange={e => setFilterMedium(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
              <option value="all">Tüm Mediumlar</option>
              <option value="cpc">CPC</option>
              <option value="social">Social</option>
              <option value="paid">Paid</option>
              <option value="video">Video</option>
              <option value="newsletter">Newsletter</option>
            </select>
            <button className="h-[38px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-400 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-line text-champagne-500 text-[14px]" /></div>
              Tarih Aralığı
            </button>
          </div>
        </div>

        {/* UTM Table */}
        <div className="bg-white rounded-2xl shadow-card overflow-hidden">
          <div className="px-6 py-4 border-b border-border flex items-center justify-between">
            <div>
              <h3 className="text-[15px] font-semibold text-charcoal-600">UTM Performans Tablosu</h3>
              <p className="text-[12px] text-charcoal-300 mt-0.5">{filtered.length} UTM parametresi</p>
            </div>
            <button className="flex items-center gap-2 h-[32px] px-3.5 bg-[#FAF8F4] border border-border rounded-xl text-[12px] text-charcoal-400 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-download-line text-[13px]" /></div>
              CSV
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-[#FAF8F4] border-b border-border">
                  {['Kaynak', 'Medium', 'Kampanya', 'İçerik', 'Anahtar', 'Oturum', 'Dönüşüm', 'Dönüşüm %', 'Ort. Süre', 'Event/Oturum', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-[11px] font-semibold text-charcoal-300 uppercase tracking-wide whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((row, idx) => (
                  <>
                    <tr key={row.id} className={`border-b border-border hover:bg-[#FAF8F4] transition-colors ${idx % 2 === 0 ? '' : 'bg-[#FDFCFA]'}`}>
                      <td className="px-4 py-3 text-[12px] font-semibold text-charcoal-600">{row.utmSource}</td>
                      <td className="px-4 py-3">
                        <span className="px-2 py-0.5 bg-charcoal-50 rounded-full text-[11px] text-charcoal-500 font-medium">{row.utmMedium}</span>
                      </td>
                      <td className="px-4 py-3 text-[12px] text-charcoal-500 max-w-[160px] truncate">{row.utmCampaign}</td>
                      <td className="px-4 py-3 text-[12px] text-charcoal-400 max-w-[100px] truncate">{row.utmContent || '—'}</td>
                      <td className="px-4 py-3 text-[12px] text-charcoal-400 max-w-[100px] truncate">{row.utmTerm || '—'}</td>
                      <td className="px-4 py-3 text-[13px] font-medium text-charcoal-500">{row.sessions.toLocaleString()}</td>
                      <td className="px-4 py-3 text-[13px] font-medium text-charcoal-500">{row.conversions}</td>
                      <td className="px-4 py-3">
                        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold ${row.conversionRate >= 7 ? 'bg-green-50 text-green-600' : row.conversionRate >= 5 ? 'bg-champagne-50 text-champagne-700' : 'bg-red-50 text-red-400'}`}>
                          {row.conversionRate}%
                        </span>
                      </td>
                      <td className="px-4 py-3 text-[12px] text-charcoal-500 font-mono">{row.avgDuration}</td>
                      <td className="px-4 py-3 text-[12px] text-charcoal-500">{row.eventsPerSession}</td>
                      <td className="px-4 py-3">
                        <button onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-champagne-50 text-charcoal-300 hover:text-champagne-600 transition-colors cursor-pointer">
                          <i className={`${expandedRow === row.id ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-[16px]`} />
                        </button>
                      </td>
                    </tr>
                    {expandedRow === row.id && (
                      <tr key={`exp-${row.id}`} className="border-b border-border bg-champagne-50/30">
                        <td colSpan={11} className="px-6 py-4">
                          <div className="grid grid-cols-3 gap-4">
                            <div>
                              <p className="text-[11px] text-charcoal-300 mb-1">Tam UTM URL Parametreleri</p>
                              <code className="text-[11px] text-charcoal-500 bg-white rounded-lg px-3 py-2 block font-mono">
                                utm_source={row.utmSource}&utm_medium={row.utmMedium}&utm_campaign={row.utmCampaign}
                                {row.utmContent ? `&utm_content=${row.utmContent}` : ''}
                                {row.utmTerm ? `&utm_term=${row.utmTerm}` : ''}
                              </code>
                            </div>
                            <div>
                              <p className="text-[11px] text-charcoal-300 mb-1">Performans Özeti</p>
                              <div className="bg-white rounded-xl p-3 space-y-1">
                                <div className="flex justify-between text-[12px]"><span className="text-charcoal-400">Oturum Başına Lead</span><span className="font-semibold">{(row.conversions / row.sessions * 100).toFixed(1)}%</span></div>
                                <div className="flex justify-between text-[12px]"><span className="text-charcoal-400">Toplam Event</span><span className="font-semibold">{Math.round(row.sessions * row.eventsPerSession).toLocaleString()}</span></div>
                              </div>
                            </div>
                            <div>
                              <p className="text-[11px] text-charcoal-300 mb-1">Hızlı Aksiyonlar</p>
                              <div className="flex gap-2">
                                <button className="flex-1 h-[32px] bg-white border border-border rounded-xl text-[12px] text-charcoal-500 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap">Rapor Oluştur</button>
                                <button className="flex-1 h-[32px] bg-white border border-border rounded-xl text-[12px] text-charcoal-500 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap">Ziyaretçileri Gör</button>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}
